export default class {
  services = [];

  constructor(parent) {
    this.parent = parent;
  }

  set(data) {
    if (data.additionalServicePrices != null) {
      const services = data.additionalServicePrices.filter(it => {
        return it.serviceClass.value != 3;
      }).map(item => (
        {
          id: item.service.value,
          name: item.name,
          price: item.price,
          description: item.description,
          count: 0,
          fullPrice: 0,
          isGroup: item.isGroupService,
          checked: false,
        }
      ));
      this.services = services.sort(function (a, b) {
        if (a.isGroup > b.isGroup) {
          return 1;
        }
        if (a.isGroup < b.isGroup) {
          return -1;
        }
        return 0;
      });
    } else {
      this.services = [];
    }
  }
  get data() {
    const services = this.services.filter(z => {
      return z.count > 0
    }).map(it => (
      {
        ServiceId: it.id,
        Quantity: it.count,
      }
    ));

    const hotel = this.parent.hotel.hotelRoom;
    if (hotel.length) {
      const a = hotel.split("__");
      services.push({
        ServiceId: a[0],
        Quantity: 1,
        ServiceVariantPriceId: a[1],
      })
    }
    return services;
  }

  add(value) {
    const index = this.services.findIndex(i => i.id === value.id);
    const item = this.services[index];
    const count = item.count + 1;
    const fullPrice = count * item.price;
    this.services[index].count = count;
    this.services[index].fullPrice = fullPrice;
  }

  remove(value) {
    const index = this.services.findIndex(i => i.id === value.id);
    const item = this.services[index];
    let count = item.count - 1;
    if (count < 0) count = 0;
    const fullPrice = count * item.price;
    this.services[index].count = count;
    this.services[index].fullPrice = fullPrice;
  }

  change(value) {
    const index = this.services.findIndex(i => i.id === value.id);
    let count = 0;
    let fullPrice = 0;
    if (value.checked) {
      count = 1;
      fullPrice = value.price;
    }
    this.services[index].count = count;
    this.services[index].fullPrice = fullPrice;
  }

  get allActiveService() {
    return this.services.filter(x => x.count > 0);
  }
}
